import React from "react";
import Header from "../header/Header";
import StatusFooter from "./StatusFooter";
import StatusHeader from "./StatusHeader";
import { useLocation } from "react-router-dom";

const PageNotFound = () => {
  const pathname = useLocation();
  const isIFrame = pathname.pathname.includes("/v1/ABSLI/CP_PayPremium/x");
  return (
    <div>
      <div className="status-container">
        {!isIFrame && <StatusHeader />}
        <div className="status-contain">
          <div></div>
          <h2 className="status-heading-pnf">
            We're currently experiencing a temporary issue while processing payments. Please try again after a few minutes.
          </h2>
          {/* <p className="status-subHeading-pnf">
            Check your network and try again or check for any spelling error. If
            the error persists, then there`s something better waiting for you on
            the same platform!
            {/* <a className="status-subHeading-pnf-link" href="/">
              Homepage
            </a> 
            {/* &nbsp;or try again after sometime. 
          </p> */}
        </div>
        {/* <StatusFooter /> */}
      </div>
    </div>
  );
};


export default PageNotFound;
